if (!$s.PDPLoader) {
    $s.PDPLoader = new function() {
      const _pdps = {};
      this._pdps = _pdps; // for debugging
      let uidSequence = 0; // Used to generate unique section IDs as they can be pulled from the same PDP template.
      // Get the main product section of a PDP, used by product cards.
      this.getMainSection = (productUrl, container) => {
        productUrl = productUrl.split('?')[0];
        productUrlKey = productUrl;
        let view = '';
        if (!container) {
          container = document;
        }
        productUrlKey += '?section_id=product_card_ajax';
        let el = container.querySelector(`.product-main-element[data-product-url="${productUrl}"]`);
        if (el) {
          return Promise.resolve(()=>{return el});
        }
        if (!_pdps[productUrlKey]) {
          _pdps[productUrlKey] = new Promise((resolve, reject) => {
            fetch(productUrlKey)
              .then(response => response.text())
              .then(html => {
                let parser = new DOMParser();
                uidSequence++;
                html.replaceAll('shopify-section-product_card_ajax', 'card-'+uidSequence+'-shopify-section-product_card_ajax');
                let doc = parser.parseFromString(html, 'text/html');
                let el = doc.querySelector(`.product-main-element[data-product-url="${productUrl}"]`);
                resolve(()=>{return el.cloneNode(true)});
              })
          });
        }
        return _pdps[productUrlKey];
      }

      // Get all the sections of a PDP, used by product-main PDP and quickview.
      this.getAllSections = (productUrl, container) => {
        productUrl = productUrl.split('?')[0];
        productUrlKey = productUrl;
        let view = '';
        if (!container) {
          container = document;
        }
      
        // Check if we already have the sections cached
        let sectionsKey = productUrlKey + '_sections';

        let sectionsWithLoadUrl = Array.from(container.querySelectorAll(`.shopify-section[data-load-url="${productUrl}"]`));
        if (sectionsWithLoadUrl.length > 0) {
          return Promise.resolve(() => { return sectionsWithLoadUrl; });
        }

        let el = container.querySelector(`product-main.product-main-element[data-product-url="${productUrl}"]`);
        if (el) {
          let sections = Array.from(el.closest('.shopify-section').parentNode.querySelectorAll('.shopify-section'));
          sections.forEach(section => {
            section.setAttribute('data-load-url', productUrl);
          })
          return Promise.resolve(()=>{return sections});
        }        
        
        if (!_pdps[sectionsKey]) {
          _pdps[sectionsKey] = new Promise((resolve, reject) => {
            fetch(productUrlKey)
              .then(response => response.text())
              .then(html => {
                let parser = new DOMParser();
                let tempDoc = parser.parseFromString(html, 'text/html');
                uidSequence++;
                const idPrefix = 'pdp-' + uidSequence+'-';
                tempDoc.querySelectorAll('[id]').forEach((el,ix) => {
                  html = html.replaceAll(el.id, idPrefix + el.id);
                });
                
                // Clone the sections
                const getter = () => {
                  let doc = parser.parseFromString(html, 'text/html');
                  let sections = doc.querySelectorAll('main .shopify-section');
                  
                  let clonedSections = Array.from(sections).map(section => {
                    section.setAttribute('data-load-url', productUrl);
                    return section.cloneNode(true);
                  });
                  return clonedSections;
                }
                
                resolve(getter);
              })
          });
        }
        return _pdps[sectionsKey];
      }
    }
  }if (!$s.getPlpSizeGuideTemplate) {
  // PLP variant B: cache the product's own PDP size-guide template/config.
  // Requests can start on Quick View intent and are shared with panel/modal clicks.
  var _plpSizeGuideTemplates = {};
  $s.getPlpSizeGuideTemplate = function(productUrl) {
    productUrl = productUrl.split('?')[0];
    if (!_plpSizeGuideTemplates[productUrl]) {
      _plpSizeGuideTemplates[productUrl] = fetch(productUrl)
        .then((response) => {
          if (!response.ok) throw new Error('Unable to load the product size guide');
          return response.text();
        })
        .then((html) => {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('.product-main-element template[data-size-guide-template]');
        })
        .catch(() => {
          delete _plpSizeGuideTemplates[productUrl];
          return null;
        });
    }
    return _plpSizeGuideTemplates[productUrl];
  };
}

if (!$s.preloadPlpSizeGuideTemplate) {
  // Limit background PDP downloads so collection images retain network capacity.
  const queue = [];
  let activeRequests = 0;
  const runNext = () => {
    while (activeRequests < 2 && queue.length) {
      const { productUrl, resolve } = queue.shift();
      activeRequests++;
      $s.getPlpSizeGuideTemplate(productUrl).then(resolve).finally(() => {
        activeRequests--;
        runNext();
      });
    }
  };
  $s.preloadPlpSizeGuideTemplate = (productUrl) => new Promise((resolve) => {
    queue.push({ productUrl, resolve });
    runNext();
  });
}

if (!window.syncSizeGuideChartUi) {
  window.syncSizeGuideChartUi = function(root = document) {
    const scope = root && root.querySelectorAll ? root : document;
    let synced = false;
    scope.querySelectorAll('.size-guide-panel table.size-chart').forEach((table) => {
      const panel = table.closest('[role="tabpanel"]');
      if (panel && panel.hasAttribute('hidden')) return;
      table.style.removeProperty('--size-chart-col-min-width');
      void table.offsetHeight;
      const headerCells = Array.from(table.querySelectorAll('thead th'));
      if (headerCells.length === 0) return;
      const topHeaderWidth = Math.ceil(Math.max(...headerCells.map((cell) => cell.getBoundingClientRect().width))) + 40;
      if (topHeaderWidth > 0) {
        table.style.setProperty('--size-chart-col-min-width', `${topHeaderWidth}px`);
        synced = true;
      }
    });
    return synced;
  };
}
if (!window.scheduleSizeGuideChartUiSync) {
  window.scheduleSizeGuideChartUiSync = function(root = document, attempts = 8) {
    let tries = 0;
    const run = () => {
      window.bindSizeGuideChartUiModalHooks(root);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const ok = window.syncSizeGuideChartUi(root);
          tries += 1;
          if (!ok && tries < attempts) {
            setTimeout(run, 60);
          }
        });
      });
    };
    run();
  };
}
function updateSizeChartScrollIndicator(el) {
  const thumb = el._sizeChartScrollThumb;
  const track = el._sizeChartScrollTrack;
  if (!thumb) return;
  const setHidden = (hidden) => {
    thumb.style.opacity = hidden ? '0' : '1';
    thumb.style.pointerEvents = hidden ? 'none' : '';
    thumb.style.visibility = hidden ? 'hidden' : '';
    if (track) {
      track.style.opacity = hidden ? '0' : '1';
      track.style.visibility = hidden ? 'hidden' : '';
    }
  };
  const panel = el.closest('[role="tabpanel"]');
  if (panel && panel.hasAttribute('hidden')) {
    setHidden(true);
    return;
  }
  const scrollWidth = el.scrollWidth;
  const clientWidth = el.clientWidth;
  const scrollLeft = el.scrollLeft;
  const scrollRange = scrollWidth - clientWidth;
  if (scrollRange <= 1) {
    setHidden(true);
    return;
  }
  setHidden(false);
  const thumbWidth = Math.max(24, (clientWidth * clientWidth) / scrollWidth);
  const thumbMaxLeft = clientWidth - thumbWidth;
  const thumbLeft = (scrollLeft / scrollRange) * thumbMaxLeft;
  thumb.style.width = thumbWidth + 'px';
  thumb.style.transform = 'translateX(' + thumbLeft + 'px)';
}
function bindSizeChartScrollIndicators(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const selectors = '.size-guide-panel .tab-content, .tingle-modal.size-guide-modal .size-guide-tabs .tabs-wrap';
  scope.querySelectorAll(selectors).forEach((el) => {
    if (el.dataset.sizeChartScrollBound === 'true') return;
    el.dataset.sizeChartScrollBound = 'true';
    const parent = el.parentNode;
    if (!parent) return;
    parent.style.position = parent.style.position || 'relative';
    const track = document.createElement('div');
    track.className = 'size-chart-scroll-track';
    track.setAttribute('aria-hidden', 'true');
    const thumb = document.createElement('div');
    thumb.className = 'size-chart-scroll-thumb';
    thumb.setAttribute('aria-hidden', 'true');
    parent.appendChild(track);
    parent.appendChild(thumb);
    el._sizeChartScrollTrack = track;
    el._sizeChartScrollThumb = thumb;
    const handler = () => requestAnimationFrame(() => updateSizeChartScrollIndicator(el));
    el.addEventListener('scroll', handler, { passive: true });
    const ro = new ResizeObserver(handler);
    ro.observe(el);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => updateSizeChartScrollIndicator(el));
    });
  });
}
function updateAllSizeChartScrollIndicators(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const selectors = '.size-guide-panel .tab-content, .tingle-modal.size-guide-modal .size-guide-tabs .tabs-wrap';
  scope.querySelectorAll(selectors).forEach(updateSizeChartScrollIndicator);
}
if (!window.bindSizeGuideChartUiModalHooks) {
  window.bindSizeGuideChartUiModalHooks = function(root = document) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.size-guide-tabs').forEach((tabsEl) => {
      if (tabsEl.dataset.sizeGuideSyncBound === 'true') return;
      tabsEl.dataset.sizeGuideSyncBound = 'true';
      tabsEl.addEventListener('click', (event) => {
        const tabButton = event.target && event.target.closest ? event.target.closest('[role="tab"]') : null;
        if (!tabButton) return;
        window.scheduleSizeGuideChartUiSync(document, 8);
      });
      const panelObserver = new MutationObserver((mutations) => {
        const hiddenChanged = mutations.some((mutation) => mutation.type === 'attributes' && mutation.attributeName === 'hidden');
        if (!hiddenChanged) return;
        window.scheduleSizeGuideChartUiSync(document, 8);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => updateAllSizeChartScrollIndicators(document));
        });
        setTimeout(() => updateAllSizeChartScrollIndicators(document), 150);
      });
      tabsEl.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
        panelObserver.observe(panel, {attributes: true, attributeFilter: ['hidden']});
      });
    });
    bindSizeChartScrollIndicators(root);
  };
}
if (!window.bindSizeGuideChartUiTabListener) {
  window.bindSizeGuideChartUiTabListener = true;
  document.addEventListener('tabChange', (event) => {
    const target = event && event.target;
    if (!target || !target.closest) return;
    if (!target.closest('.size-guide-tabs')) return;
    const activeTab = event.detail && event.detail.activeTab;
    if (activeTab) {
      activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
    window.scheduleSizeGuideChartUiSync(document, 8);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => updateAllSizeChartScrollIndicators(document));
    });
    setTimeout(() => updateAllSizeChartScrollIndicators(document), 150);
  });
}

if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    static instanceCount = 0;

    constructor() {
      super();
      this.sectionId = this.dataset.section + '-' + ProductMain.instanceCount++; // for Unique product component IDs
      this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
      this.fillProductData();
      this.variantsElement = this.querySelector('product-variants');
      this.sellingPlanElement = this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      this.optionValues = {}
      const requiredOptionsSetting = (["Size"] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options_with_values.filter(x=>(requiredOptionsSettingUnique.indexOf(x.name)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && x.values.length>1).map(x=>x.name);
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.bindSizeGuideTriggerDelegation();

      
//preload connected products() if up to 3 products in total;
        (()=>{
          if (this.tagName == 'PRODUCT-MAIN') {
            const products = {};
            // Instead of looking at variants, look through options_with_values for product_url
            this.productData.options_with_values?.forEach(option => {
              option.values?.forEach(value => {
                if (value.product_url) {
                  // Use product_url as the key since product_id is not available anymore
                  let key = value.product_url;
                  products[key] = value.product_url;
                }
              });
            });
            if (Object.keys(products).length <= 3) {
              for (const [key, value] of Object.entries(products)) {
                $s.PDPLoader.getAllSections(value, this.closest('.shopify-section').parentNode);
              }
            }
          }
        })()}

    fillProductData() {
      const isMerge = this.productData.is_product_merge;
      if (isMerge) {
        this.productData.options_with_values.forEach((x,index)=>{
          for (let v of  this.productData.variants) {
            let option = x.values.find(y=>y.value==v.options[index]);
            if (!option) {
              option = {value: v.options[index], available: v.available};
              x.values.push(option);
            }
            option.available = option.available || v.available;
          }
        });
      }if (this.productData.is_product_main) {
        let altPerProduct = {}
        this.productData.media = Array.from(this.querySelectorAll('product-gallery [data-media-id]')).map((media)=>{
          let alt;
          if (!isMerge) {alt = media.getAttribute('data-media-alt');
          } else {
            let id = media.getAttribute('data-product-id');
            if (altPerProduct[id]) {
              alt = altPerProduct[id];
            } else {
              let variant = this.productData.variants.find(v=>v.product_id == id);
              if (variant) {
              alt = this.productData.options_with_values[0].name + ': ' + variant.options[0];
              altPerProduct[id] = alt;
              }
            }
            alt = alt + (media.getAttribute('data-media-alt') ? ';' + media.getAttribute('data-media-alt') : '');}
          return {
            "alt": alt,
            "id": media.getAttribute('data-media-id')
          };
        });
      }

    }

    bindSizeGuideTriggerDelegation() {
      if (this._sizeGuideDelegatedBound) return;
      this._sizeGuideDelegatedBound = true;
      this.addEventListener('click', (event) => {
        const btn = event.target && event.target.closest ? event.target.closest('[data-size-guide-open]') : null;
        if (!btn || !this.contains(btn)) return;
        event.preventDefault();
        event.stopPropagation();
        const tpl = this.querySelector('template[data-size-guide-template]');
        if (!tpl || !tpl.content) return;
        const fragment = tpl.content.cloneNode(true);
        $s.openModal(fragment, 'size-guide-modal');
        window.scheduleSizeGuideChartUiSync(document, 8);
      });
    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.productData.options_with_values.length;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange() {
      // Lightweight update of elements that not worth creating their own components
      var variant = event.detail.variant;
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        var percent = Math.floor((1 - variant.price / variant.compare_at_price) * 100);
        if (percent > 0) {
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });
      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant.available ? 'none' : '';
      });}}
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
        
      }


      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      this.querySelectorAll('.quick-view-trigger').forEach((btn) => {
        btn.addEventListener('click', this.openQuickView.bind(this));
      });

      // PLP variant B: independent size panel, not tied to the existing atc-options-wrapper.
      this.plpAtcButtonB = this.querySelector('.plp-atc-cta-b');
      if (this.plpAtcButtonB) {
        const sizeGuideBtn = this.querySelector('[data-plp-whats-my-size]');
        const prepareSizeGuide = () => {
          if (!sizeGuideBtn) return;
          $s.getPlpSizeGuideTemplate(sizeGuideBtn.dataset.productUrl).then((tpl) => {
            if (tpl) sizeGuideBtn.classList.remove('none');
          });
        };
        // Begin loading before the click without fetching every product on the PLP.
        this.plpAtcButtonB.addEventListener('pointerenter', prepareSizeGuide);
        this.plpAtcButtonB.addEventListener('focus', prepareSizeGuide);
        this.plpAtcButtonB.addEventListener('touchstart', prepareSizeGuide, { passive: true });
        if (sizeGuideBtn) {
          // GrowthBook exposes variant B after cards initialize. Start preloading
          // as soon as it is active, including cards added by filtering/pagination.
          const preloadWhenActive = () => {
            if (this.plpAtcButtonB.classList.contains('none')) return;
            visibilityObserver.disconnect();
            $s.preloadPlpSizeGuideTemplate(sizeGuideBtn.dataset.productUrl).then((tpl) => {
              if (tpl) sizeGuideBtn.classList.remove('none');
            });
          };
          const visibilityObserver = new MutationObserver(preloadWhenActive);
          visibilityObserver.observe(this.plpAtcButtonB, { attributes: true, attributeFilter: ['class'] });
          preloadWhenActive();
        }
        this.plpAtcButtonB.addEventListener('click', (e) => {
          e.preventDefault();
          let panel = this.querySelector('.plp-atc-panel');
          if (!panel) return;
          let hasOptions = panel.querySelector('product-swatch, product-dropdown');
          if (!hasOptions) {
            if (this.querySelector('.btn.add')) this.querySelector('.btn.add').click();
            return;
          }
          panel.classList.remove('none');
          this.plpAtcButtonB.classList.add('none');
          prepareSizeGuide();
        });
        let plpCancelBtn = this.querySelector('[data-plp-atc-cancel]');
        if (plpCancelBtn) {
          plpCancelBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.querySelector('.plp-atc-panel').classList.add('none');
            this.plpAtcButtonB.classList.remove('none');
          });
        }
        let plpWhatsMySizeBtn = this.querySelector('[data-plp-whats-my-size]');
        if (plpWhatsMySizeBtn) {
          plpWhatsMySizeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            $s.getPlpSizeGuideTemplate(plpWhatsMySizeBtn.dataset.productUrl).then((tpl) => {
              if (!tpl) return;
              let fragment = tpl.content.cloneNode(true);
              $s.openModal(fragment, 'size-guide-modal');
              window.scheduleSizeGuideChartUiSync(document, 8);
            });
          });
        }
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('product-swatch.color-swatches:not([data-related-variant-swatches="true"])');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            var pv = origSwatches.closest('product-variants');
            var tag = pv.outerHTML.replace('name="id"', '');
            var wrapper = document.createElement('div');
            wrapper.style.display = 'none';
            //must insert as Element, not HTML, otherwise the component would be reconstructed
            self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
            tag = tag.replace('<product-swatch', '<product-swatch data-trim-options-limit="4"');
            wrapper.innerHTML = tag;
            //move the swatches inside the add-to-cart-form component to use existing css.
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches:not([data-related-variant-swatches="true"])'));
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
      if (this.dataset.quickAddRedirect === 'true') {
        this.addEventListener('click', (e)=>{
          var addBtn = e.target.closest && e.target.closest('button.add');
          var quickViewBtn = e.target.closest && e.target.closest('.quick-view-trigger');
          if ((addBtn || quickViewBtn) && this.contains(addBtn || quickViewBtn)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.redirectToProductPage();
          }
        }, true);
      }
    }

    redirectToProductPage() {
      var link = this.querySelector('.product-card-url');
      var url = link ? link.getAttribute('href') : this.dataset.productUrl;
      var variant = this.getCurrentVariant && this.getCurrentVariant();
      if (variant && variant.id) {
        url = url.split('?')[0] + '?variant=' + variant.id;
      }
      location = url;
    }

    // Added to match colors on product cards loaded through ajax, probably not needed for main product sections
    copySchemeFrom(el) {
      var lookForClasses = ['scheme','color-scheme-1-white','color-scheme-1','color-scheme-2','color-scheme-3','color-scheme-980ff022-1a9a-4f7a-9f35-fcf8193200d3','color-scheme-b0d325e7-04cc-496c-9416-7dbdd9a9441c','color-scheme-bb0c18fd-1967-4ee6-a379-7911719896cb','color-scheme-dd9904eb-643f-45f9-b0d2-1cc4eda78e63','color-scheme-f16ea826-bf3e-4310-abbb-21127b7d9cd3','color-scheme-d0183b67-1bdf-4fe0-ad12-2ac7652d8e5c', 'same-scheme-true', 'same-scheme-false'];
      lookForClasses.forEach(name=>{
        if (el.classList.contains(name)) {
          this.classList.add(name);
        } else {
          this.classList.remove(name);
        }
      })
      
    }

    openOptions(e) {
      e.preventDefault()
      if (this.dataset.quickAddRedirect === 'true') {
        this.redirectToProductPage();
        return;
      }
      const currentVariant = this.getCurrentVariant();
      if (currentVariant && currentVariant.available) {
        const inputs = this.querySelectorAll(
          'input:not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="reset"]), textarea, select'
        );
        if (inputs.length==0) {
          if (this.querySelector('.btn.add')) this.querySelector('.btn.add').click();
          return;
        }
      }
      
      if (this.querySelector('.atc-options-wrapper').classList.contains('open')) {
        return;
      }
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      if (this.dataset.quickAddRedirect === 'true') {
        this.redirectToProductPage();
        return;
      }
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          section.dataset.source = 'default';
          window.__quickviewSource = 'default';
          var sectionProductMain = section.querySelector('.product-main-element');
          if (sectionProductMain) {
            sectionProductMain.dataset.quickviewSource = 'default';
          }
          var quickViewModal = $s.openModal(section, 'product-quick-view');
          if (quickViewModal && quickViewModal.modal) {
            quickViewModal.modal.dataset.source = 'default';
          }
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant.featured_media && super.isSwatchSelected() ? variant.featured_media : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      // Update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.productData.options_with_values.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }

      const option2Value = variant?.options?.[1];
      if (option2Value) {
        const swatch2 = this.querySelector('product-swatch[data-option="2"]');
        const input =
          swatch2 &&
          Array.from(swatch2.querySelectorAll('input[type="radio"]')).find((el) => el.value === option2Value);
      
        if (input) input.click();
      }    
    }
    
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

(function() {
  function publishUpsellQuickViewClick(btn) {
    if (!btn || !window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
    Shopify.analytics.publish('custom:upsell_cta_clicked', {
      button_name: btn.getAttribute('data-button-name') || btn.getAttribute('aria-label') || (btn.textContent || '').trim(),
      button_location: btn.getAttribute('data-button-location') || 'upsell_metafield',
      upsell_product_title: btn.getAttribute('data-upsell-product-title') || btn.getAttribute('data-button-name') || '',
      upsell_product_price: btn.getAttribute('data-upsell-product-price') || '',
      upsell_product_price_cents: Number(btn.getAttribute('data-upsell-product-price-cents') || 0),
      main_product_title: btn.getAttribute('data-main-product-title') || ''
    });
  }

  function openUpsellQuickView(e) {
    var upsellBtn = e.target.closest('.upsell-metafield .quick-view-trigger');
    var btn = upsellBtn || e.target.closest('.ctl-section .ctl-plus');
    if (!btn) return;
    if (btn.dataset.quickAddRedirect === 'true' && btn.dataset.url) {
      e.preventDefault();
      location = btn.dataset.url;
      return;
    }
    if (!btn.dataset.url) return;
    if (upsellBtn) publishUpsellQuickViewClick(upsellBtn);
    e.preventDefault();
    e.stopPropagation();
    var quickViewSource = upsellBtn ? 'upsell' : 'default';
    var qvUrl = btn.dataset.url;
    $s.showLoadingOverlay();
    $s.get({
      url: qvUrl,
      success: function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var section = doc.querySelector('.product-main-element').closest('.shopify-section');
        if (!section) return;
        var enhancedDescription = section.querySelector('.enhanced-description');
        if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
          var openAcc = enhancedDescription.querySelector('.accordion.open');
          var expandedBtn = enhancedDescription.querySelector('[aria-expanded=true]');
          if (openAcc) openAcc.classList.remove('open');
          if (expandedBtn) expandedBtn.ariaExpanded = false;
          enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
        }
        section.dataset.source = quickViewSource;
        window.__quickviewSource = quickViewSource;
        var sectionProductMain = section.querySelector('.product-main-element');
        if (sectionProductMain) {
          sectionProductMain.dataset.quickviewSource = quickViewSource;
        }
        var quickViewModal = $s.openModal(section, 'product-quick-view');
        if (quickViewModal && quickViewModal.modal) {
          quickViewModal.modal.dataset.source = quickViewSource;
        }
        $s.globalEval(section);
      },
      always: function() {
        $s.hideLoadingOverlay();
      }
    });
  }
  document.addEventListener('click', openUpsellQuickView);
})();

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      if (this.button != this.mainAddButton) {
        if (this.button) this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      var stickyPanel = this.closest('product-sticky-panel');
      var requiredBtn = this.querySelector('.btn.selection-required');
      if (stickyPanel && requiredBtn) {
        requiredBtn.addEventListener('click', (event)=>{
          event.preventDefault();
          var variantEdit = stickyPanel.querySelector('product-variant-edit');
          if (variantEdit) {
            variantEdit.open({ focusTarget: 'toggle' });
          }
        });
      }

      this.mainElement.addEventListener('variantChange', (e)=>{
        var stickyPanel = this.closest('product-sticky-panel');
        var requiredBtn = this.querySelector('.btn.selection-required');
        if (this.required() && requiredBtn) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
        } else if(e.detail.variant && e.detail.variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          if (this.querySelector('.btn.add')) this.querySelector('.btn.add').style.display = '';
          if (this.querySelector('.plp-atc-cta-b')) {
            const plpAtcButtonB = this.querySelector('.plp-atc-cta-b');
            plpAtcButtonB.classList.remove('disabled');
            plpAtcButtonB.textContent = plpAtcButtonB.ariaLabel;
          }
          if (this.querySelector('.sold-out-message')) this.querySelector('.sold-out-message').style.display = 'none';
          if (requiredBtn) requiredBtn.style.display = 'none';
          var bisContainer = document.getElementById('klaviyo-bis-button-container');
          if (bisContainer) bisContainer.style.display = 'none';
      	} else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          if (this.querySelector('.btn.add')) this.querySelector('.btn.add').style.display = 'none';
          if (this.querySelector('.plp-atc-cta-b')) {
            const plpAtcButtonB = this.querySelector('.plp-atc-cta-b');
            plpAtcButtonB.classList.add('disabled');
            plpAtcButtonB.textContent = plpAtcButtonB.dataset.soldout;
          }
          if (this.querySelector('.sold-out-message')) this.querySelector('.sold-out-message').style.display = '';
          if (requiredBtn) requiredBtn.style.display = 'none';
          var bisContainer = document.getElementById('klaviyo-bis-button-container');
          if (bisContainer) bisContainer.style.display = '';
      	}
        if (stickyPanel) {
          stickyPanel.refreshTabPriority();
        }
      });
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              var optionIndex = this.mainElement.productData.options_with_values.findIndex(x=>x.name==key.trim());
              if(optionIndex>=0 && values) {
                var found = false;
                values.split(',').forEach((value)=>{
                  if(variant.options[optionIndex]==value.trim()) {
                    found = true;
                  }
                });
                show = found;
              }
            }
          });
        }
        if(show) {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
        } else {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
        }
      });
      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();
      this.videoAutoplay = this.dataset.videoAutoplay;
      this.autoplayOptionsElement = this.videoAutoplay ? this.querySelector('.autoplay-options') : null;
      this.autoplayCheck = this.autoplayOptionsElement ? this.autoplayOptionsElement.querySelector('input') : null;
      this.itemsPerViewMobile = this.dataset.itemsPerViewMobile ? this.dataset.itemsPerViewMobile/1 : 1.1;
      this.itemsPerViewDesktop = this.dataset.itemsPerViewDesktop ? this.dataset.itemsPerViewDesktop/1 : 1;

      if (this.autoplayCheck) {
        this.autoplayCheck.addEventListener('change', (e)=>{
          Cookies.set('autoplay', e.target.checked ? 'enabled' : 'disabled');
        });
        this.autoplayCheck.checked = Cookies.get('autoplay') !== 'disabled';
      }

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant);
        if(variant.featured_media && this.mainElement.isSwatchSelected()) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            loop: true,
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.mobileStyle=='carousel') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            loop: true,
            slidesPerView: this.itemsPerViewMobile,
            autoplay: false,
            spacing: 5
          }
        }
        if(this.mobileStyle=='thumbnails') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            loop: true,
            slidesPerView: this.itemsPerViewMobile,
            autoplay: false,
            spacing: 5
          }
        }
        var mobileQuery = '(max-width: '+window.breakpoints.small+')';
        if(this.querySelector('.keen-arrow') && breakpoints[mobileQuery]) {
          breakpoints[mobileQuery].prevButton = this.querySelector('.keen-arrow.prev');
          breakpoints[mobileQuery].nextButton = this.querySelector('.keen-arrow.next');
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 0.001) +'rem)'] = {
            loop: true,
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }

        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          autoplay: false,
          duration: 1800,
          pageInfo: this.querySelector('.keen-slider-page'),
          slidesPerView: this.itemsPerViewDesktop,
          spacing: 5,
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            let canPlay = true;
            if (this.autoplayOptionsElement) {
              this.autoplayOptionsElement.classList.remove('visible');
            }
            if (this.videoAutoplay) {
              const media = keen.currentSlide().querySelector('.media');
              if (this.autoplayOptionsElement && media) { // && media is to only show the checkbox on video slides.
                this.autoplayOptionsElement.classList.add('visible');
                //TODO eval  checkbox
                this.autoplayCheck.checked = canPlay = Cookies.get('autoplay')!='disabled';
              }
              if (media && canPlay) {
                $s.playMedia(media);
              }
            }
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId, false);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle.indexOf('thumbnails')>-1) || ($s.media.isMediumUp && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          loop: true,
          slidesPerView: 4,
          spacing: 10,
          centered: false,
          ...(this.mobileStyle=='thumbnails_vertical' ? {
            vertical: true
          } : {vertical: false})
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          loop: true,
          slidesPerView: 5,
          spacing: 10,
          centered: false,
          ...(this.mobileStyle=='thumbnails_vertical' ? {
            vertical: true
          } : {vertical: false})
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: false,
          slidesPerView: 5,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            slidesPerView: 5
          } : {})
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      if (!this.mainElement) return;
      this.finalPriceElement = this.querySelector('.final');
      this.comparePriceElement = this.querySelector('.compare');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false

      if(this.mainElement.classList.contains('product-card')){
        var originalPricePrefix = '<span class="visually-hidden">'+lngg.product__original_price_label+': </span>'
        var finalPricePrefix = '<span class="visually-hidden">. '+lngg.product__final_price_label+': </span>'
      }else{
        var originalPricePrefix = '<span class="visually-hidden">'+lngg.product__original_price_label+': </span>'
        var finalPricePrefix = '<span class="visually-hidden">. '+lngg.product__final_price_label+': </span>'
      }

      this.listenEvents = ['variantChange','sellingPlanChange'];
      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var data = this.mainElement.getCurrentPlan() || this.mainElement.getCurrentVariant();
        	if(data) {
            var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
        		this.finalPriceElement.innerHTML = $s.formatMoney(data.price * quantity).replace('.00','');

            if(data.compare_at_price > data.price) {
              this.comparePriceElement.classList.remove('hide');
              this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(data.compare_at_price * quantity).replace('.00','');
        		  this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(data.price * quantity).replace('.00','');
            } else {
              this.comparePriceElement.classList.add('hide');
              this.comparePriceElement.innerHTML = '';
            }
        	} else {
        		this.finalPriceElement.innerHTML = '';
            this.comparePriceElement.innerHTML = '';
        	}
          this.mainElement.dispatchEvent(new CustomEvent('priceChange', {detail: {price: data.price * quantity}}));
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }
      })
      this.combinedListingOptions = [];
      
        this.mainElement.productData.options_with_values.forEach((option, index) => {
          let skipThisOption = false;
          for (let i = 0; i < option.values.length; i++) {
            if (!this.mainElement.productData.variants.some(v => v.options[index] == option.values[i].value)) {
              this.combinedListingOptions.push(option);
              break;
            }
          }
        })
      

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
        
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}));
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

      if (this.swatchImg) {
          //var variant = this.mainElement.productData.variants.
          var optionIndex = this.swatchImg.dataset.option/1 -1;
          this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
            var label = radio.parentNode.querySelector('.label-inner');
            
            var matchingVariant = this.mainElement.productData.variants.find(v => {
              if (v.options[optionIndex] !== radio.value) return false;
              // All other options must match the current variant
              for (let i = 0; i < v.options.length; i++) {
                if (i === optionIndex) continue;
                if (v.options[i] !== variant.options[i]) return false;
              }
              return true;
            });
            if (!matchingVariant) {
              matchingVariant = this.mainElement.productData.variants.find(
                v => v.options[optionIndex] == radio.value
              );
            }
            let img = label.querySelector('img');
            if (matchingVariant.featured_media) {
              if (!img) {
                img = document.createElement('img');
                img.loading = 'lazy';
                img.width = 80;
                img.height = 80;
                img.alt = '';
                label.appendChild(img);
              }
              img.src = $s.imgUrlFilter(matchingVariant.featured_media.src, '80x');
              img.style.display = '';
            } else {
              if (img) {
                img.style.display = 'none';
              }
            }
          });

      }

    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options_with_values.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = this.previousVariant ? newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]) : [];
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          
            if (this.combinedListingHandle(variant, optionIdx, e)) {
              //is handled by combined listing when the new variant is from a different product
              //then do not refresh options, load a different PDP or sections
              return;
            }
          
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    
    combinedListingHandle(variant, optionIdx, e) {
      let productUrl = '';
      if (!variant) {
        let optionValue = this.mainElement.productData.options_with_values[optionIdx].values.find(x=>x.value==e.target.value);
        if (optionValue.product_url) {
          productUrl = optionValue.product_url;
        }
      } else if (variant.product_id != this.mainElement.productData.product_id) {
        productUrl = variant.product_url;
      }

      if (productUrl) {const productUrlWithoutParams = productUrl.split('?')[0];
          const isCard = this.mainElement.tagName == 'PRODUCT-CARD-ATC';
          const isPdp = !!(this.mainElement.productData && this.mainElement.productData.is_product_main);
          // If the theme setting is single_page_async (needed for product cards),
          // force PDP behavior to match "redirect" on combined-listing cross-product changes.
          if (!isCard && isPdp) {
            location = productUrl;
            return true;
          }
          if (isCard) {
            $s.PDPLoader.getMainSection(productUrl, this.mainElement.parentNode).then(getter=>{
              const el = getter();
              const isCard = this.mainElement.tagName == 'PRODUCT-CARD-ATC';
              if (!this.mainElement.parentNode.contains(el)) {
                this.mainElement.insertAdjacentElement('afterend', el);
                if (isCard) {
                  el.copySchemeFrom(this.mainElement);
                }
              }
              this.mainElement.style.display = 'none';
              el.style.display = '';
              if (isCard && this.mainElement.classList.contains('expand')) {
                el.openOptions(new Event('click'));
              }
              const variant = el.variantsElement.calculateNewVariant(optionIdx, e.target.value);
              el.variantsElement.refreshOptions(optionIdx-1, variant);
              el.variantsElement.variantChange(variant);
              try {
                el.variantsElement.querySelector('[data-option="'+(optionIdx+1)+'"] select, [data-option="'+(optionIdx+1)+'"] input[value="'+e.target.value+'"]').focus();
              } catch (e) {
                console.error(e);
              }
            });
          } else {
            // for PDP and quickview
            $s.PDPLoader.getAllSections(productUrl, this.closest('.shopify-section').parentNode).then(getter=>{
              const sections = getter();
              // Find the main product section
              const productSection = sections.find(section => 
                section.querySelector('.product-main-element[data-product-url="' + productUrlWithoutParams + '"]')
              );
              
              if (productSection) {
                const productElement = productSection.querySelector('.product-main-element[data-product-url="' + productUrlWithoutParams + '"]');
                
                // Hide existing sections from previous products
                const mainContainer = this.closest('.shopify-section').parentNode;
                const existingSections = mainContainer.querySelectorAll('.shopify-section');
                existingSections.forEach(section => {
                  section.style.display = 'none';
                });
                
                // Insert all new sections
                const isQuickView = !!this.closest('.product-quick-view');
                sections.forEach(section => {
                  if (isQuickView && section != productSection) {
                    return;
                  }
                  mainContainer.insertAdjacentElement('beforeend', section);
                  section.style.display = '';
                });
                
                // Hide current product element and show new one
                this.mainElement.style.display = 'none';
                productElement.style.display = '';
                
                const variant = productElement.variantsElement.calculateNewVariant(optionIdx, e.target.value);
                productElement.variantsElement.refreshOptions(optionIdx-1, variant);
                productElement.variantsElement.variantChange(variant);
                
                try {
                  productElement.variantsElement.querySelector('[data-option="'+(optionIdx+1)+'"] select, [data-option="'+(optionIdx+1)+'"] input[value="'+e.target.value+'"]').focus();
                } catch (e) {
                  console.error(e);
                }
              }
            });
          }
          return true;}
      return false;
    }
    
    
    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content scheme" style="width: ${infoLink.dataset.width}rem">
                <img alt="" src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    // Get values with availability that depends on previous options
    getOptionValues(currentVariant) {
      var options = [];
      var mainProductId = this.mainElement.productData.product_id;
      var variants = this.mainElement.productData.variants.filter(
        v => v.product_id === mainProductId
      );
      options = structuredClone(this.mainElement.productData.options_with_values.map(x=>x.values));
      options.forEach((values, index) => {
        
          /* when combined products feature is enabled the options_with_values first option contains the correct availability of values */
        
        let filteredVariants = variants;
        for (let prev = 0; prev < index; prev++) {
          filteredVariants = filteredVariants.filter(
            v => v.options[prev] === currentVariant.options[prev]
          );
        }
        let retValues = [];
        values.forEach((valueObj) => {
          const allVariantsForValue = filteredVariants.filter(
            v => v.options[index] === valueObj.value
          );
          const matchingVariants = allVariantsForValue.filter(
            v => v.product_id === mainProductId
          );
          
          if (matchingVariants.length > 0) {
            let foundAvailable = false;
            matchingVariants.forEach(v => {
              if (v.available === true) {
                foundAvailable = true;
              }
            });
            const newValueObj = {
              value: valueObj.value,
              available: foundAvailable
            };
            if (valueObj.product_url) {
              newValueObj.product_url = valueObj.product_url;
            }
            retValues.push(newValueObj);
          }
        })
        options[index] = retValues;
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{
          btn.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
          if (divVariants) {
            divVariants.setAttribute('aria-hidden', 'false');
          }
        });
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{
          btn.classList.remove('open');
          btn.setAttribute('aria-expanded', 'false');
          if (divVariants) {
            divVariants.setAttribute('aria-hidden', 'true');
          }
        });
      }
      var stickyPanel = this.closest('product-sticky-panel');
      if (stickyPanel) {
        setTimeout(()=>{ stickyPanel.refreshTabPriority(); }, 450);
      }
    }

    open(options) {
      options = options || {};
      if (!this.editing) {
        this.onToggle();
      }
      if (options.focusTarget === 'toggle' && this.toggles[0]) {
        this.toggles[0].focus();
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      if (this.dataset.relatedVariantSwatches === 'true') {
        return;
      }
      this.colorSwatchesOptions = ["Color","Color \/ Pattern"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement ? this.variantsElement.getOptionInfoIcon(this.label) || '' : '';
      this.infoLink = this.variantsElement ? this.variantsElement.getOptionInfoLink(this.label) || '' : '';
      this.trimOptionsLimit = this.dataset.trimOptionsLimit ? parseInt(this.dataset.trimOptionsLimit) : null;
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);

      this.buildOptionSelector();
      this.bindKeyboardSelection();
    }

    bindKeyboardSelection() {
      if (this.keyboardBound) {
        return;
      }
      this.keyboardBound = true;
      this.addEventListener('keydown', (e)=>{
        if (e.key !== 'Enter') {
          return;
        }
        var radio = this.getRadioFromKeyboardTarget(e.target);
        if (!radio) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    getRadioFromKeyboardTarget(target) {
      if (!target || !target.closest) {
        return null;
      }
      if (!this.contains(target)) {
        return null;
      }
      if (target.matches('input[type="radio"]')) {
        return target;
      }
      if (target.matches('label[for]')) {
        return document.getElementById(target.getAttribute('for'));
      }
      var swatch = target.closest('.swatch');
      if (swatch) {
        return swatch.querySelector('input[type="radio"]:not([disabled])');
      }
      return null;
    }

    getSizeGuideConfig() {
      const data = this.mainElement?.dataset || {};
      return {
        enabled: data.sizeGuideEnabled === 'true',
        hidden: data.sizeGuideHidden === 'true',
        hasSizeOption: data.sizeGuideHasSizeOption === 'true',
        buttonLabel: data.sizeGuideButtonLabel || '',
        optionNames: (data.sizeGuideOptionNames || '')
          .split(',')
          .map((s) => s.trim().toLowerCase())
          .filter(Boolean),
        colorOptionNames: (data.sizeGuideColorOptionNames || '')
          .split(',')
          .map((s) => s.trim().toLowerCase())
          .filter(Boolean),
      };
    }

    isSizeGuideOption() {
      const cfg = this.getSizeGuideConfig();
      if (!cfg.enabled) return false;
      const label = (this.label || '').trim().toLowerCase();
      if (!label) return false;
      if (cfg.hasSizeOption) {
        return cfg.optionNames.includes(label);
      }
      return cfg.colorOptionNames.includes(label) || label === 'color' || label === 'colour';
    }

    getSizeGuideButtonHtml() {
      const cfg = this.getSizeGuideConfig();
      if (cfg.hidden || !this.isSizeGuideOption()) return '';
      return `
        <button
          type="button"
          class="size-guide-trigger option-info-link link"
          data-size-guide-open="true"
        >${cfg.buttonLabel}</button>
      `;
    }

    bindSizeGuideTrigger() {
      const btn = this.querySelector('[data-size-guide-open]');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const tpl = this.mainElement?.querySelector('template[data-size-guide-template]');
        if (!tpl || !tpl.content) return;
        const fragment = tpl.content.cloneNode(true);
        $s.openModal(fragment, 'size-guide-modal');
        window.scheduleSizeGuideChartUiSync(document, 8);
      });
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
      var selectedTitleHtml = this.classList.contains('color-swatches') ? `<div class="selected-swatch-title" aria-live="polite">${defaultValue || ''}</div>` : '';
      var optionNameRow = this.classList.contains('color-swatches')
        ? `<div class="option-name-row flex align-items-center"><div class="option-name small-label">${this.infoIcon}<span id="${this.getAttribute('aria-labelledby')}">${this.label}: </span><span aria-hidden="true" class="option-value">${defaultValue}</span>${this.infoLink}${this.getSizeGuideButtonHtml()}</div>${selectedTitleHtml}</div>`
        : `<div class="option-name small-label">${this.infoIcon}<span id="${this.getAttribute('aria-labelledby')}">${this.label}: </span><span aria-hidden="true" class="option-value">${defaultValue}</span>${this.infoLink}${this.getSizeGuideButtonHtml()}</div>`;
  		var html = `
        ${optionNameRow}
        <div class="swatch-group flex flex-wrap"></div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue);
      this.bindSizeGuideTrigger();
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }
      const isInteractive = !this.closest('[aria-hidden="true"]');
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch2-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        let isAvailable = false;
        if (option.hasOwnProperty('available')) {
          isAvailable = option.available === true;
        }
        var soldOut = (!isAvailable ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
        
        if (!this.trimOptionsLimit || index < this.trimOptionsLimit) {
          html += `
            <div class="swatch" data-available="${isAvailable}">
              <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" ${!isInteractive ? 'tabindex="-1"':''} />
              <label for="${id}">
                <div class="label-inner flex align-items-center justify-content-center animation ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}">
                  <span>${option.value}${soldOut}</span>
                </div>
              </label>
            </div>
          `;
        } else if (index === this.trimOptionsLimit) {
          html += `<div class="swatch swatch-remaining">+${options.length - this.trimOptionsLimit} ${lngg.product_card__swatches_more}</div>`;
        }
  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
      if (this.classList.contains('color-swatches')) {
        var titleEl = this.querySelector('.selected-swatch-title');
        if (titleEl) {
          var updateSelectedTitle = function() {
            var checked = group.querySelector('input:checked');
            titleEl.textContent = checked ? checked.value : '';
          };
          group.addEventListener('change', updateSelectedTitle);
          updateSelectedTitle();
        }
      }
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }
    }

    getSizeGuideConfig() {
      const data = this.mainElement?.dataset || {};
      return {
        enabled: data.sizeGuideEnabled === 'true',
        hidden: data.sizeGuideHidden === 'true',
        hasSizeOption: data.sizeGuideHasSizeOption === 'true',
        buttonLabel: data.sizeGuideButtonLabel || '',
        optionNames: (data.sizeGuideOptionInfoNames || data.sizeGuideOptionNames || '')
          .split(',')
          .map((s) => s.trim().toLowerCase())
          .filter(Boolean),
        colorOptionNames: (data.sizeGuideColorOptionNames || '')
          .split(',')
          .map((s) => s.trim().toLowerCase())
          .filter(Boolean),
      };
    }

    isSizeGuideOption() {
      const cfg = this.getSizeGuideConfig();
      if (!cfg.enabled) return false;
      const label = (this.label || '').trim().toLowerCase();
      if (!label) return false;
      if (cfg.hasSizeOption) {
        return cfg.optionNames.includes(label);
      }
      return cfg.colorOptionNames.includes(label) || label === 'color' || label === 'colour';
    }

    getSizeGuideButtonHtml() {
      const cfg = this.getSizeGuideConfig();
      if (cfg.hidden || !this.isSizeGuideOption()) return '';
      return `
        <button
          type="button"
          class="size-guide-trigger option-info-link link"
          data-size-guide-open="true"
        >${cfg.buttonLabel}</button>
      `;
    }

    bindSizeGuideTrigger() {
      const btn = this.querySelector('[data-size-guide-open]');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const tpl = this.mainElement?.querySelector('template[data-size-guide-template]');
        if (!tpl || !tpl.content) return;
        const fragment = tpl.content.cloneNode(true);
        $s.openModal(fragment, 'size-guide-modal');
        window.scheduleSizeGuideChartUiSync(document, 8);
      });
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      const isInteractive = !this.closest('[aria-hidden="true"]');
      var html = `
        <div class="option-name small-label option-name--with-actions">
          <label class="option-name-label" for="${optionId}">
            ${this.infoIcon}${this.label}:
            ${this.infoLink}
          </label>
          ${this.getSizeGuideButtonHtml()}
        </div>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"/></svg> 
          <select id="${optionId}" name="swatch-${optionId}" ${!isInteractive ? 'tabindex="-1"':''}></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
      this.bindSizeGuideTrigger();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (this.required()) {
  			html += `<option value="${defaultValue || ''}" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? lngg.product_main__sold_out_option_value : '');
  			html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.checkPanelVisibility.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
      this.mainButtons = this.mainElement.querySelector('product-buttons');
      this.tabAccessHandler = this.onDocumentTab.bind(this);
    }

    connectedCallback() {
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
        this.checkPanelVisibility();
      }
      if (this.mainButtons && typeof IntersectionObserver !== 'undefined') {
        this.intersectionObserver = new IntersectionObserver((entries)=>{
          this.mainButtonsVisible = entries[0].isIntersecting;
          this.checkPanelVisibility();
        }, {threshold: 0});
        this.intersectionObserver.observe(this.mainButtons);
      }
      document.addEventListener('keydown', this.tabAccessHandler, true);
      if (this.dataset.stickyMode !== 'slide') {
        this.setPanelOpen(true);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
      document.removeEventListener('keydown', this.tabAccessHandler, true);
      this.setPanelOpen(false);
    }

    isPanelActive() {
      return this.dataset.stickyMode !== 'slide' || this.classList.contains('open');
    }

    getVisibleFocusables() {
      if (!this.isPanelActive()) {
        return [];
      }
      var nodes = this.querySelectorAll('.wrapper button, .wrapper a[href], .wrapper input:not([type="hidden"]):not([disabled]), .wrapper select:not([disabled]), .wrapper textarea:not([disabled])');
      return Array.from(nodes).filter((el)=>{
        if (el.closest('.variants[aria-hidden="true"]')) {
          return false;
        }
        var style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
    }

    refreshTabPriority() {
      if (!this.isPanelActive()) {
        return;
      }
      this.setTabPriority(false);
      this.setTabPriority(true);
    }

    setTabPriority(enabled) {
      this.getVisibleFocusables().forEach((el)=>{
        if (enabled) {
          if (!el.hasAttribute('data-sticky-tab-priority')) {
            el.setAttribute('data-sticky-tab-priority', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '_none_');
          }
          el.setAttribute('tabindex', '1');
        } else if (el.hasAttribute('data-sticky-tab-priority')) {
          var prev = el.getAttribute('data-sticky-tab-priority');
          if (prev === '_none_') {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', prev);
          }
          el.removeAttribute('data-sticky-tab-priority');
        }
      });
    }

    setPanelOpen(open) {
      if (open === this.showing) {
        return;
      }
      if (open) {
        this.classList.add('open');
        this.showing = true;
        this.setTabPriority(true);
      } else {
        this.classList.remove('open');
        this.showing = false;
        this.setTabPriority(false);
      }
    }

    checkPanelVisibility() {
      if (this.dataset.stickyMode !== 'slide') {
        return;
      }
      var shouldShow = false;
      if (this.positionElement) {
        var bounds = this.positionElement.getBoundingClientRect();
        shouldShow = bounds.bottom < 0;
      }
      if (this.mainButtonsVisible === false) {
        shouldShow = true;
      }
      this.setPanelOpen(shouldShow);
    }

    onDocumentTab(e) {
      if (e.key !== 'Tab' || e.shiftKey || !this.isPanelActive()) {
        return;
      }
      var focusables = this.getVisibleFocusables();
      if (!focusables.length) {
        return;
      }
      var active = document.activeElement;
      if (this.contains(active)) {
        return;
      }
      var focusBeforePanel = !active || active === document.body;
      if (!focusBeforePanel) {
        focusBeforePanel = !!(active.compareDocumentPosition(this) & Node.DOCUMENT_POSITION_FOLLOWING);
      }
      if (!focusBeforePanel) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      focusables[0].focus();
    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}




(function () {
  if (window.__comingSoonKlaviyoBound) {
    return
  }
  window.__comingSoonKlaviyoBound = true
  var comingSoonKlaviyoRevision = '2025-10-15'

  function buildComingSoonKlaviyoEventPayload(email, productId, productName) {
    var uid =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : String(Date.now()) + '-' + productId + '-' + String(email).replace(/[^a-zA-Z0-9]/g, '').slice(0, 48)
    return {
      data: {
        type: 'event',
        attributes: {
          properties: {
            ProductID: productId,
            ProductName: productName,
            URL: typeof location !== 'undefined' ? location.href : ''
          },
          unique_id: uid,
          metric: {
            data: {
              type: 'metric',
              attributes: {
                name: 'Coming Soon Product Interest',
                service: 'api'
              }
            }
          },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        }
      }
    }
  }

  function postComingSoonKlaviyoEvent(companyId, email, productId, productName, revision) {
    var rev = revision || comingSoonKlaviyoRevision
    return fetch(
      'https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: rev
        },
        body: JSON.stringify(buildComingSoonKlaviyoEventPayload(email, productId, productName)),
        mode: 'cors',
        credentials: 'omit'
      }
    ).then(function (res) {
      if (res.status === 202 || res.ok) {
        return res
      }
      if (rev === comingSoonKlaviyoRevision) {
        return postComingSoonKlaviyoEvent(companyId, email, productId, productName, '2026-01-15')
      }
      return res
    })
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return
    var t = e.target
    if (!t || !t.matches || !t.matches('.coming-soon-klaviyo input[name="email"]')) return
    e.preventDefault()
    e.stopPropagation()
    var root = t.closest('.coming-soon-klaviyo')
    var submitBtn = root && root.querySelector('.coming-soon-klaviyo-submit')
    if (submitBtn) submitBtn.click()
  })
  document.addEventListener(
    'click',
    function (e) {
      var el = e.target
      if (el && el.nodeType !== 1) {
        el = el.parentElement
      }
      var btn = el && el.closest ? el.closest('.coming-soon-klaviyo-submit') : null
      if (!btn) return
      e.preventDefault()
      e.stopPropagation()
      var root = btn.closest('.coming-soon-klaviyo')
      if (!root || root.getAttribute('data-submitting') === 'true') return
      var emailInput = root.querySelector('input[name="email"]')
      var productNameInput = root.querySelector('input[name="product_name"]')
      var productIdInput = root.querySelector('input[name="product_id"]')
      var errorEl = root.querySelector('.error-msg')
      var successEl = root.querySelector('.coming-soon-klaviyo-success-message')
      var controlsEl = root.querySelector('.coming-soon-klaviyo-controls')
      var email = emailInput && emailInput.value ? emailInput.value.trim() : ''
      if (!emailInput || !$s.validateEmail(email)) {
        if (errorEl) {
          errorEl.textContent = lngg.general__forms__enter_a_valid_email_message
          errorEl.classList.remove('hide')
        }
        return
      }
      if (errorEl) {
        errorEl.classList.add('hide')
        errorEl.textContent = ''
      }
      var companyId = root.getAttribute('data-klaviyo-company-id')
      var listId = root.getAttribute('data-klaviyo-list-id')
      if (!companyId || !listId) return
      root.setAttribute('data-submitting', 'true')
      btn.disabled = true
      var productName = productNameInput ? productNameInput.value : ''
      var productId = productIdInput ? String(productIdInput.value) : ''
      var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Product coming soon',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  product_name: productName,
                  product_id: productId
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
      }
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2025-10-15'
        },
        body: JSON.stringify(payload),
        mode: 'cors',
        credentials: 'omit'
      })
        .then(function (res) {
          if (res.status === 202 || res.ok) {
            if (controlsEl) controlsEl.hidden = true
            var subtitleEl = root.querySelector('.coming-soon-klaviyo-subtitle')
            if (subtitleEl) subtitleEl.hidden = true
            if (successEl) successEl.hidden = false
            postComingSoonKlaviyoEvent(companyId, email, productId, productName).catch(function () {})
            return
          }
          return res.json().then(
            function (body) {
              var detail = lngg.product_main__coming_soon_notify_error
              if (body && body.errors && body.errors[0] && body.errors[0].detail) {
                detail = body.errors[0].detail
              }
              throw new Error(detail)
            },
            function () {
              throw new Error(lngg.product_main__coming_soon_notify_error)
            }
          )
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err && err.message ? err.message : lngg.product_main__coming_soon_notify_error
            errorEl.classList.remove('hide')
          }
        })
        .finally(function () {
          root.removeAttribute('data-submitting')
          btn.disabled = false
        })
    },
    true
  )
})()
